module.exports = __webpack_public_path__ + "static/media/fryingBg.d697a6ed.jpg";